import React from "react";
import classes from "./Footer.module.css";

const Footer = () => {
  
  return (
    <footer className={classes.footer}>
      <div className={classes.footer_container}>
        <p className={classes.p}>© {new Date().getFullYear()} UVCANN SOLUTIONS LLP</p>
      </div>
    </footer>
  );
};

export default Footer;